import { useCallback, useId, useRef, useState, type RefObject } from 'react';
import type { PopoverCloseReason } from './BrowserPopover';

export interface BrowserPopoverState {
    isOpen: boolean;
    popoverId: string;
    anchorRef: RefObject<HTMLDivElement>;
    triggerRef: RefObject<HTMLButtonElement>;
    toggle: () => void;
    close: (reason: PopoverCloseReason) => void;
}

// Focus goes back to the trigger unless the user clicked or tabbed somewhere else.
export function useBrowserPopover(): BrowserPopoverState {
    const [isOpen, setIsOpen] = useState(false);
    const popoverId = useId();
    const anchorRef = useRef<HTMLDivElement>(null);
    const triggerRef = useRef<HTMLButtonElement>(null);

    const toggle = useCallback(() => setIsOpen((open) => !open), []);
    const close = useCallback((reason: PopoverCloseReason) => {
        setIsOpen(false);
        if (reason !== 'outside') triggerRef.current?.focus();
    }, []);

    return { isOpen, popoverId, anchorRef, triggerRef, toggle, close };
}
